import React from 'react';
import Login from './Login'
import PasswordReset from './PasswordReset'
import { Grid, Row, Col } from 'react-bootstrap';
//import logo from '../../resources/images/header_logo.svg';

const Landing = (props) => {

    return <Grid>
        <Row>
            <Col xs={12} sm={3}/>
            <Col xs={12} sm={6}>
                {props.passwordReset ? <PasswordReset /> : <Login />}
            </Col>
            <Col xs={12} sm={3}/>
        </Row>
    </Grid>
}

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing.jsx